//
// Imports
//

import { getElementOrThrow, getStringDataOrThrow } from "@lorenstuff/browser-utilities";

//
// Component
//

export function setActiveGlobalNavigationButton(name: string)
{
	if (name == "")
	{
		name = "home";
	}

	const globalNavigation = getElementOrThrow(document, ".component-global-navigation");

	const buttons = globalNavigation.querySelectorAll<HTMLElement>(".component-button");

	for (const button of buttons)
	{
		const buttonName = getStringDataOrThrow(button, "name");

		if (buttonName == name)
		{
			button.classList.add("current");
		}
		else
		{
			button.classList.remove("current");
		}
	}
}